<template>
  <div class="step-resumo">
    <!-- Informações -->
    <div class="step-resumo__section">
      <div class="section-label">Informações</div>
      <div class="step-resumo__grid">
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Título</span>
          <span class="step-resumo__field-value">
            {{ item.titulo || "—" }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Descrição</span>
          <span class="step-resumo__field-value">
            {{ item.descricao || "—" }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Prioridade</span>
          <span class="step-resumo__field-value">
            {{ item.prioridade ? 'Prioritário' : 'Normal' }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Sistemas</span>
          <span class="step-resumo__field-value">
            <span v-if="canaisAtivos.length > 0">
              {{ canaisAtivos.join(", ") }}
            </span>
            <span v-else class="step-resumo__field-value--muted">Nenhum</span>
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Ativo</span>
          <span class="step-resumo__field-value">
            {{ item.ativo ? "Sim" : "Não" }}
          </span>
        </div>
        <div class="step-resumo__field">
          <span class="step-resumo__field-label">Exibe percentual de margem</span>
          <span class="step-resumo__field-value">
            {{ item.exibirPercentual ? "Sim" : "Não" }}
          </span>
        </div>
      </div>
    </div>

    <!-- Faixas de Lucratividade -->
    <div class="step-resumo__section">
      <div class="section-label">Faixas de Lucratividade</div>

      <div v-if="sortedRegras.length === 0" class="step-resumo__empty">
        Nenhuma faixa configurada
      </div>
      <div v-else>
        <div class="step-resumo__faixa-header">
          <span class="step-resumo__faixa-header-col step-resumo__faixa-header-col--cor"></span>
          <span class="step-resumo__faixa-header-col step-resumo__faixa-header-col--char">Ind.</span>
          <span class="step-resumo__faixa-header-col step-resumo__faixa-header-col--label">Nome</span>
          <span class="step-resumo__faixa-header-col step-resumo__faixa-header-col--margem">Margem Mín.</span>
          <span class="step-resumo__faixa-header-col step-resumo__faixa-header-col--status">Status</span>
        </div>
        <div class="step-resumo__list">
          <div
            v-for="regra in sortedRegras"
            :key="regra.originalIndex"
            class="step-resumo__faixa-wrapper"
          >
            <div class="step-resumo__faixa-item">
              <span class="step-resumo__faixa-swatch" :style="{ background: regra.cor }"></span>
              <span class="step-resumo__faixa-char">{{ regra.indicador || "—" }}</span>
              <span class="step-resumo__faixa-label">{{ regra.label }}</span>
              <span class="step-resumo__faixa-margem">
                {{ regra.margemMinima }}%
              </span>
              <span class="step-resumo__faixa-status-col">
                <span
                  v-if="getStatusFaixa(regra.margemMinima)"
                  class="step-resumo__faixa-status"
                  :style="{
                    backgroundColor: getStatusFaixa(regra.margemMinima).bg,
                    color: getStatusFaixa(regra.margemMinima).color,
                    borderColor: getStatusFaixa(regra.margemMinima).color + '30',
                  }"
                >
                  {{ getStatusFaixa(regra.margemMinima).label }}
                </span>
              </span>
            </div>
            <div v-if="regra.orientacao" class="step-resumo__faixa-orientacao">
              <fa-icon icon="info-circle" class="step-resumo__faixa-orientacao-icon" />
              <span>{{ regra.orientacao }}</span>
            </div>
          </div>
        </div>

        <div class="step-resumo__thresholds">
          <div class="step-resumo__threshold-item">
            <span class="step-resumo__field-label">Analisa a partir de</span>
            <span class="step-resumo__field-value">
              {{ item.margemMinimaAnalisar !== null ? item.margemMinimaAnalisar + '%' : 'Sem faixa de análise' }}
            </span>
          </div>
          <div class="step-resumo__threshold-item">
            <span class="step-resumo__field-label">Libera a partir de</span>
            <span class="step-resumo__field-value">
              {{ item.margemMinimaLiberar !== null ? item.margemMinimaLiberar + '%' : '—' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Restrições -->
    <div class="step-resumo__section">
      <div class="section-label">Restrições</div>
      <div v-if="item.restricoes.length === 0" class="step-resumo__empty">
        Sem restrições
      </div>
      <div v-else class="step-resumo__list">
        <div
          v-for="(restricao, idx) in item.restricoes"
          :key="idx"
          class="step-resumo__list-item"
        >
          <span class="step-resumo__list-badge">
            {{ getRestricaoLabel(restricao.tipo) }}
          </span>
          <span>{{ restricao.chave }}</span>
        </div>
      </div>
    </div>

    <!-- Checklist de Validação -->
    <div class="step-resumo__section" v-if="checklist.length > 0">
      <div class="section-label section-label--warning">
        Pendências para resolver
      </div>
      <ul class="step-resumo__checklist">
        <li
          v-for="(pendencia, idx) in checklist"
          :key="idx"
          class="step-resumo__checklist-item"
        >
          <CIcon name="cil-warning" size="sm" class="mr-1" />
          {{ pendencia }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepResumo",
  props: {
    item: { type: Object, required: true },
    tiposRestricao: { type: Array, default: () => [] },
  },
  computed: {
    canaisAtivos() {
      const canais = [];
      if (this.item.aplicacallcenter) canais.push("Callcenter");
      if (this.item.aplicafv) canais.push("Força de Vendas");
      return canais;
    },
    sortedRegras() {
      return [...this.item.regras]
        .map((r, i) => ({ ...r, originalIndex: i }))
        .sort((a, b) => a.margemMinima - b.margemMinima);
    },
    checklist() {
      const p = [];
      if (!this.item.titulo) p.push("Título não preenchido");
      if (!this.item.aplicafv && !this.item.aplicacallcenter)
        p.push("Nenhum sistema selecionado");
      if (this.item.regras.length === 0)
        p.push("Nenhuma faixa adicionada");
      if (this.item.margemMinimaLiberar === null)
        p.push("'Libera a partir de' não definido");
      if (
        this.item.margemMinimaAnalisar !== null &&
        this.item.margemMinimaLiberar !== null &&
        this.item.margemMinimaAnalisar >= this.item.margemMinimaLiberar
      )
        p.push("'Analisa a partir de' deve ser menor que 'Libera a partir de'");
      return p;
    },
  },
  methods: {
    getRestricaoLabel(tipo) {
      const found = (this.tiposRestricao || []).find((t) => t.chave === tipo);
      return found ? found.label : tipo;
    },
    getStatusFaixa(margemMinima) {
      const { margemMinimaAnalisar, margemMinimaLiberar } = this.item;

      if (margemMinimaLiberar === null) return null;

      if (margemMinima >= margemMinimaLiberar) {
        return { label: "Liberado para envio", color: "#00C853", bg: "#00C85314" };
      }

      if (margemMinimaAnalisar !== null && margemMinima >= margemMinimaAnalisar) {
        return { label: "Disponível para análise", color: "#FF9800", bg: "#FF980014" };
      }

      return { label: "Bloqueado", color: "#FF1744", bg: "#FF174414" };
    },
  },
};
</script>

<style scoped>
.step-resumo__section {
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.step-resumo__section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.section-label--warning {
  color: #f37b1d;
}

.step-resumo__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.step-resumo__field {
  display: flex;
  flex-direction: column;
}

.step-resumo__field-label {
  font-size: 11px;
  color: #999;
  margin-bottom: 2px;
}

.step-resumo__field-value {
  font-size: 13px;
  color: #333;
}

.step-resumo__field-value--muted {
  color: #aaa;
  font-style: italic;
}

.step-resumo__empty {
  font-size: 13px;
  color: #aaa;
  font-style: italic;
}

.step-resumo__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.step-resumo__list-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  padding: 4px 0;
}

.step-resumo__list-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: #f2f2f8;
  color: #3a3e81;
}

/* Faixas resumo */
.step-resumo__faixa-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  margin-bottom: 4px;
  border-bottom: 1px solid #e4e7eb;
}

.step-resumo__faixa-header-col {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
}

.step-resumo__faixa-header-col--cor { flex: 0 0 18px; }
.step-resumo__faixa-header-col--char { flex: 0 0 32px; text-align: center; }
.step-resumo__faixa-header-col--label { flex: 1; min-width: 0; }
.step-resumo__faixa-header-col--margem { flex: 0 0 80px; }
.step-resumo__faixa-header-col--status { flex: 0 0 180px; }

.step-resumo__faixa-wrapper {
  padding: 6px 0;
  border-bottom: 1px dashed #f0f0f0;
}

.step-resumo__faixa-wrapper:last-child {
  border-bottom: none;
}

.step-resumo__faixa-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}

.step-resumo__faixa-swatch {
  flex: 0 0 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.step-resumo__faixa-char {
  flex: 0 0 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 6px;
  border-radius: 5px;
  background: #f2f2f8;
  color: #3a3e81;
  font-family: "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji",
    "SFMono-Regular", Menlo, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid #e4e4f1;
}

.step-resumo__faixa-label {
  flex: 1;
  min-width: 0;
  font-weight: 600;
  color: #1d2939;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.step-resumo__faixa-margem {
  flex: 0 0 80px;
  color: #667085;
}

.step-resumo__faixa-status-col {
  flex: 0 0 180px;
  display: flex;
  justify-content: flex-start;
}

.step-resumo__faixa-orientacao {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 4px;
  font-size: 12px;
  color: #667085;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.step-resumo__faixa-orientacao-icon {
  color: #98a2b3;
  margin-top: 3px;
  flex-shrink: 0;
}

.step-resumo__faixa-status {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  border: 1px solid;
  white-space: nowrap;
  flex-shrink: 0;
}

.step-resumo__thresholds {
  display: flex;
  gap: 24px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed #e4e7eb;
}

.step-resumo__threshold-item {
  display: flex;
  flex-direction: column;
}

/* Checklist */
.step-resumo__checklist {
  list-style: none;
  padding: 0;
  margin: 0;
}

.step-resumo__checklist-item {
  font-size: 13px;
  color: #d9534f;
  padding: 4px 0;
  display: flex;
  align-items: center;
}
</style>
